import { getDOMComponents } from '@bacons/mdx'

export const mdxComponents = {
  ...getDOMComponents(),
  h1: (props: any) => <h1 {...props} className="text-3xl font-bold mb-6 mt-4 text-foreground" />,
  h2: (props: any) => (
    <h2 {...props} className="text-2xl font-semibold mb-4 mt-6 text-foreground" />
  ),
  h3: (props: any) => <h3 {...props} className="text-xl font-semibold mb-3 mt-5 text-foreground" />,
  p: (props: any) => <p {...props} className="text-base leading-6 mb-4 text-muted-foreground" />,
  ul: (props: any) => <ul {...props} className="ml-4 mb-4 list-disc" />,
  li: (props: any) => (
    <li {...props} className="text-base leading-6 mb-2 pl-2 text-muted-foreground" />
  ),
  a: (props: any) => (
    <a
      {...props}
      className="text-primary underline decoration-primary/30 hover:decoration-primary transition-colors"
    />
  ),
}
